import { render } from "./CabinetHistory.vue?vue&type=template&id=422b8d0e"
import script from "./CabinetHistory.vue?vue&type=script&lang=js"
export * from "./CabinetHistory.vue?vue&type=script&lang=js"

import "./CabinetHistory.vue?vue&type=style&index=0&id=422b8d0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__